import Vue from 'vue'
import App from './index.vue'
import store from './store'
import mixin from './mixin'
import './directives'
import './filters'
import login from '@tencent/vft-common/login'
import { reportPlugin, dialogPlugin } from '@tencent/vft-vue-plugins'
import LoginPanel from '@tencent/vft-vue-plugins/src/login'

Vue.config.productionTip = false

reportPlugin.configBossId({ bossId: 3754, pwd: 598288292 }, [{ bossId: 3753, pwd: 1449912345 }, { bossId: 5814, pwd: 1682996435 }])
Vue.use(reportPlugin, { reportVip: true, store: store })
Vue.use(dialogPlugin)
Vue.use(LoginPanel)
Vue.mixin(mixin)

login.init(() => {
  new Vue({
    render: h => h(App),
    store
  }).$mount('#app')
})
